import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import { cn } from '@/utils/cn';
import { TYPE } from '@/lib/typography';

export function CalendarLegend({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        TYPE.small,
        'mt-s4 flex flex-wrap items-center gap-x-s5 gap-y-s2 text-ds-muted',
        className,
      )}
      data-testid="calendar-legend"
    >
      <span className="inline-flex items-center gap-s2">
        <i className="inline-block h-3 w-1 rounded-sm bg-ds-teal" aria-hidden />
        {t('appointments.legend.journal_finalized')}
      </span>
      <span className="inline-flex items-center gap-s2">
        <i className="inline-block h-3 w-1 rounded-sm bg-ds-teal-line" aria-hidden />
        {t('appointments.legend.journal_draft')}
      </span>
      <span className="inline-flex items-center gap-s2">
        <i className="inline-block h-3 w-1 rounded-sm border border-dashed border-ds-line-strong bg-ds-line-strong" aria-hidden />
        {t('appointments.legend.cancelled_dashed')}
      </span>
      <span className="hidden items-center gap-s2 nav:inline-flex">
        <Info className="h-3.5 w-3.5" aria-hidden />
        {t('appointments.legend.weekend_closed')}
      </span>
    </div>
  );
}
